import React, { MouseEventHandler, useMemo } from "react";

import { Button, Stack, Typography } from "@mui/material";
import { startCase } from "lodash";
import { MRT_Column } from "material-react-table";

import { useRenderDateValue } from "../../../hooks";
import { ClientDealTableRow, DealTableColumn, ReportTableColumn } from "../../../store/types";

type Props = {
  column: MRT_Column<ClientDealTableRow>;
  onClick: MouseEventHandler;
  indexName?: string;
  isBenchmarkTable?: boolean;
};

export const TableHeader = ({ column, onClick, isBenchmarkTable }: Props) => {
  const { def: colDef, data: colData } = column.columnDef.meta as { def: ReportTableColumn; data: DealTableColumn };

  const previewDate = useRenderDateValue();

  const drText = !colDef.dateRange ? "" : previewDate(colDef.dateRange);
  const currencyText = !colDef.currency ? "" : colDef.currency;

  const buttonText = useMemo(() => {
    // For benchmark tables, only show date range (no currency)
    if (isBenchmarkTable) {
      return drText || "";
    }

    // For non-benchmark tables, show both date range and currency
    if (drText && currencyText) {
      return `${drText}, ${currencyText}`;
    }
    if (drText && !currencyText) {
      return drText;
    }
    if (!drText && currencyText) {
      return currencyText;
    }
    return "Default";
  }, [drText, currencyText, isBenchmarkTable]);

  // const showButton =
  //   //@ts-ignore
  //   otherColumns.some((col) => col.columnDef.meta?.def?.aggregation === colDef.aggregation);

  return (
    <Stack alignItems="flex-start">
      <Typography>{colData.title}</Typography>
      {buttonText && (
        <Button
          size="sm"
          variant="text"
          sx={{ position: "relative", minWidth: 40, color: "#496682", backgroundColor: "#DBE8F5" }}
          onClick={onClick}
        >
          {startCase(buttonText)}
        </Button>
      )}
    </Stack>
  );
};
